
// @ts-nocheck
export class InitAEM {
  constructor() {
    try {
      this.aes = new (window as any).AES({
        pid: "ZJSrX2",
        user_type: `mozi_youkudsp`,
        env: (window as any).pageVars?.app?.env,
        version: "1.0.3",
        debug: (window as any).pageVars?.app?.env == 'pre' ? 1 : 0,
        plugin_perf_resourceTimingSampling: 0.1,
        uid: undefined,
        requiredFields: ["uid"]
      })

      // 初始化SDK
      this.aes.log = this.aes.before(this.aes.log, (type, data) => {
        return [type, data]

      })

      this.pv = this.aes.use((window as any).AESPluginPV, {
        autoPV: true,
        autoLeave: true,
        enableHistory: false,
      });
      this.perf = this.aes.use((window as any).AESPluginPerf);
      let abort;
      const markMcp = () => {
        // 触发mcp埋点
        abort && abort();
        abort = this.perf.markOnMCP((entry) => { }, { c2: location.pathname }).abort;
      };
      window.addEventListener('popstate', () => {
        this.pv.sendPV();
        markMcp();
      });
      window.addEventListener("load", (event) => {
        markMcp();
      });
      (window as any).AdsTrackerPlugins = this.aes.use([
        (window as any).AESPluginPV,
        (window as any).AESPluginEvent,
        (window as any).AESPluginJSError,
        (window as any).AESPluginAPI,
        (window as any).AESPluginResourceError,
        (window as any).AESPluginPerf,
        (window as any).AESPluginEventTiming,
        (window as any).AESPluginAutolog,
        (window as any).AESPluginEmogine,
        (window as any).AESPluginAnimFluency,
        (window as any).AESPluginBlank,
        (window as any).AESPluginLongTask
      ]);
      (window as any).aes = this.aes;
    } catch (e) {
      console.log('aem初始化失败', e)
    }
  }
  sendPV(params) {
    this.pv.sendPV(params);
  }
  setConfig(config) {
    this.aes.setConfig(config);
  }
}
